import { render, staticRenderFns } from "./display-form.vue?vue&type=template&id=2bc493f8&scoped=true&"
import script from "./display-form.ts?vue&type=script&lang=ts&"
export * from "./display-form.ts?vue&type=script&lang=ts&"
import style0 from "./display-form.scss?vue&type=style&index=0&id=2bc493f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc493f8",
  null
  
)

export default component.exports